import React, { Component } from "react";
import Switch from "react-switch";
import Navbar from "../../components/Navbar.js";
import { Modal, Toast } from "react-bootstrap";
import {
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  Status,
  loading,
  float,
} from "../../components/CustomComponent.js";
import { stripJuristic } from "../../components/text-sanitize.js";
import Pagination from "@mui/material/Pagination";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
export default class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,
      modal_detail: false,

      filter_search: "",
      count: 0,

      data: [],
      data_role: [],
      data_project: [],

      user_id: "",
      username: "",
      password: "",
      user_type: "",
      role_id: "",
      project_list: [],
      address: "",
      full_name: "",
      email: "",
      phone: "",
      pin_number: "",
      is_active: false,

      confirm_password: "",
    };
  }

  async componentDidMount() {
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_search } = this.state;
    loading(true);
    let data, count, data_role, data_project;
    let [result_user, result_role, result_project] = await Promise.all([
      GET("api/admin/user/list", { page: page, data_search: filter_search }),
      GET("api/admin/role/list", null),
      GET("api/public/project", null),
    ]);
    if (result_user?.status) {
      data = result_user.data;
      count = result_user.count;
    }
    if (result_role?.status) {
      data_role = result_role.data;
    }
    if (result_project?.status) {
      data_project = result_project.data;
    }
    this.setState({ data, count, data_role, data_project, page: page || 1 });
    loading(false);
  };
  CreateUpdate = async () => {
    const {
      user_id,
      username,
      password,
      confirm_password,
      user_type,
      role_id,
      project_list,
      address,
      full_name,
      email,
      phone,
      pin_number,
      is_active,
    } = this.state;
    if (!full_name) {
      alert("", "warning", "แจ้งเตือน", "กรุณาระบุชื่อ - นามสกุล");
      return;
    }
    if (!phone) {
      alert("", "warning", "แจ้งเตือน", "กรุณาระบุเบอร์โทรศัพท์");
      return;
    }
    if (!role_id) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกสิทธิ์ผู้ใช้งาน");
      return;
    }
    if (!email) {
      alert("", "warning", "แจ้งเตือน", "กรุณาระบุอีเมล");
      return;
    }
    if (!username) {
      alert("", "warning", "แจ้งเตือน", "กรุณาระบุชื่อผู้ใช้");
      return;
    }
    if (password !== confirm_password) {
      alert("", "warning", "แจ้งเตือน", "รหัสผ่านไม่ตรงกัน");
      return;
    }

    loading(true);
    let body = {
      username,
      password,
      user_type,
      role_id,
      project_list,
      address,
      full_name,
      email,
      phone,
      pin_number,
      is_active,
    };
    let result = !user_id
      ? await POST("api/admin/user/create", body)
      : await PUT("api/admin/user/update/" + user_id, body);
    if (result?.status) {
      alert("#", "success");
    }
    loading(false);
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "info",
        "ยืนยัน",
        "ยืนยันการลบข้อมูลนี้หรือไม่?",
        "ลบข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await DELETE("api/admin/user/delete/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  render() {
    const { modal_create,
      modal_update,
      modal_detail,

      filter_search,
      count,

      data,
      data_role,
      data_project,

      user_id,
      username,
      password,
      user_type,
      role_id,
      project_list,
      address,
      full_name,
      email,
      phone,
      pin_number,
      is_active,

      confirm_password, } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar
          header="Transaction History"
          page1="หน้าหลัก"
          page2="ผู้ใช้"
        />
        <div className="body px-3 pb-3 pt-0">
          <h4 className="fw-bold mb-2">ผู้ใช้</h4>
          <div className="d-flex align-items-center flex-wrap">
            <input
              type="text"
              className="form-control wpx-250 me-2 mb-2"
              placeholder="รหัสผู้ใช้, ชื่อ-สกุล..."
              onChange={(e) => {
                this.setState({ filter_search: e.target.value });
              }}
              value={filter_search}
            />
            <div className="d-flex">
              <button
                className="btn btn-success px-4 me-2 mb-2"
                onClick={() => {
                  this.Get(1);
                }}
              >
                ค้นหา
              </button>
              <button
                className="btn btn-outline-success px-4 me-2 mb-2"
                onClick={() => {
                  window.location.reload();
                }}
              >
                ล้างค่า
              </button>
            </div>
            <button
              className="btn btn-success px-4 ms-auto mb-2"
              onClick={async () => {
                this.setState({
                  modal_create: true,
                  username: "",
                  password: "",
                  user_type: "",
                  role_id: "",
                  project_list: [],
                  address: "",
                  full_name: "",
                  email: "",
                  phone: "",
                  pin_number: "",
                  is_active: true,
                });
              }}
            >
              เพิ่มผู้ใช้
            </button>
          </div>
          <div className="card rounded border-0 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="bg-light text-secondary">
                  <tr>
                    <th className="wpx-50 text-center">ลำดับ</th>
                    <th>รหัสผู้ใช้</th>
                    <th>ชื่อ - สกุล</th>
                    <th>อีเมล</th>
                    <th>เบอร์โทรศัพท์</th>
                    <th>สถานะ</th>
                    <th className="text-center wpx-90">จัดการ</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={"table_" + index}>
                      <td className="text-center">{((this.state.page || 1) - 1) * 10 + index + 1}</td>
                      <td>{item.user_code}</td>
                      <td>{item.full_name}</td>
                      <td>{item.email}</td>
                      <td>{item.phone}</td>
                      <td>
                        {item.is_active
                          ? Status("ใช้งาน", "success")
                          : Status("ปิดใช้งาน", "danger")}
                      </td>
                      <td className="py-1">
                        <div className="d-flex justify-content-center">
                          {/* Update */}
                          <div
                            className="icon text-14 mx-1 d-flex align-items-center justify-content-center wpx-25 hpx-25 pointer rounded-3 bg-warning-light text-orange"
                            onClick={async () => {
                              this.setState({
                                modal_update: true,
                                user_id: item.user_id,
                                username: item.username,
                                password: "",
                                user_type: item.user_type,
                                role_id: item.role?.uid || "",
                                project_list: item.project_list || [],
                                address: item.address,
                                full_name: item.full_name,
                                email: item.email,
                                phone: item.phone,
                                pin_number: item.pin_number,
                                is_active: item.is_active,
                              });
                            }}
                          >
                            {"\uf044"}
                          </div>
                          {/* Delete */}
                          <div
                            className="icon text-14 mx-1 d-flex align-items-center justify-content-center wpx-25 hpx-25 pointer rounded-3 bg-danger-light text-danger"
                            onClick={async () => {
                              this.Delete(item.user_id);
                            }}
                          >
                            {"\uf1f8"}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-between p-3">
            <small>ทั้งหมด {count} รายการ</small>
            <Pagination
              count={Math.ceil(count / 10)}
              showFirstButton
              showLastButton
              onChange={(_, page) => {
                this.Get(page);
              }}
            />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          onHide={() =>
            this.setState({ modal_create: false, modal_update: false })
          }
          size="lg"
        >
          <Modal.Header closeButton>
            <h5 className="fw-bold mb-0">
              {modal_create
                ? "เพิ่ม"
                : modal_update
                ? "แก้ไข"
                : ""}
              ผู้ใช้
            </h5>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12 col-lg-6">
                <div className="d-flex mb-2">
                  <div className="wpx-120 mt-2">ชื่อ - นามสกุล</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="กรอกข้อมูล..."
                    onChange={(e) => {
                      this.setState({ full_name: e.target.value });
                    }}
                    value={full_name}
                  />
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-120 mt-2">เบอร์โทรศัพท์</div>
                  <input
                    type="text"
                    maxLength={10}
                    className="form-control"
                    placeholder="กรอกข้อมูล..."
                    onChange={(e) => {
                      if (!float(e.target.value)) {
                        return;
                      }
                      this.setState({ phone: e.target.value });
                    }}
                    value={phone}
                  />
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-120 mt-2">สิทธิ์ผู้ใช้งาน</div>
                  <select
                    className="form-control"
                    onChange={(e) => {
                      this.setState({ role_id: e.target.value });
                    }}
                    value={role_id}
                  >
                    <option value="">-- กรุณาเลือก --</option>
                    {data_role?.map((item, index) => (
                      <option key={index} value={item.uid}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-120 mt-2">ประเภทผู้ใช้งาน</div>
                  <select
                    className="form-control"
                    onChange={(e) => {
                      this.setState({ user_type: e.target.value });
                    }}
                    value={user_type}
                  >
                    <option value="">-- กรุณาเลือก --</option>
                    <option value="admin">ผู้ดูแลระบบ</option>
                    <option value="accounting">เจ้าหน้าที่บัญชี</option>
                    <option value="finance">พนักงานการเงิน</option>
                    <option value="project_manager">ผู้จัดการประจำโครงการ</option>
                    <option value="center_manager">ผู้จัดการกลาง</option>
                    <option value="customer">ลูกบ้าน</option>
                  </select>
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-120 mt-2">อีเมล</div>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="กรอกข้อมูล..."
                    onChange={(e) => {
                      this.setState({ email: e.target.value });
                    }}
                    value={email}
                    disabled={modal_update}
                  />
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-120 mt-2">ชื่อผู้ใช้</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="กรอกข้อมูล..."
                    onChange={(e) => {
                      this.setState({ username: e.target.value });
                    }}
                    value={username}
                    disabled={modal_update}
                  />
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-120 mt-2">รหัสผ่าน</div>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="กรอกข้อมูล..."
                    onChange={(e) => {
                      this.setState({ password: e.target.value });
                    }}
                    value={password}
                  />
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-120 mt-2">ยืนยันรหัสผ่าน</div>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="กรอกข้อมูล..."
                    onChange={(e) => {
                      this.setState({ confirm_password: e.target.value });
                    }}
                    value={confirm_password}
                  />
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-120 mt-2">ใช้งาน</div>
                  <Switch
                    onChange={(e) => {
                      this.setState({ is_active: e });
                    }}
                    checked={is_active}
                  />
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center mb-3">
                  <b>โครงการที่ใช้งานได้</b>
                  <input
                    className="mx-3"
                    type="checkbox"
                    onChange={() => {
                      let _project_list = project_list;
                      if (
                        _project_list.length === data_project.length
                      ) {
                        _project_list = [];
                      } else {
                        _project_list = data_project?.map(
                          (e) => e.project_id
                        );
                      }
                      this.setState({ project_list: _project_list });
                    }}
                    checked={
                      project_list?.length === data_project?.length
                    }
                  />
                  <span>ทั้งหมด</span>
                </div>
                <div className="overflow-scroll" style={{ maxHeight: "70vh" }}>
                  {data_project?.map((item) => (
                    <div className="d-flex">
                      <input
                        className="me-3"
                        type="checkbox"
                        onChange={() => {
                          let _project_list = project_list;
                          if (_project_list.includes(item.project_id)) {
                            _project_list = _project_list.filter(
                              (e) => e !== item.project_id
                            );
                          } else {
                            _project_list.push(item.project_id);
                          }
                          this.setState({ project_list: _project_list });
                        }}
                        checked={project_list.includes(
                          item.project_id
                        )}
                      />
                      <span>{stripJuristic(item.project_name)}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <div className="w-100 d-flex justify-content-end">
              <button
                className="btn btn-success px-4 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-danger px-4 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
